import email from '../../assets/envelope-fill.svg';
import whats from '../../assets/whatsapp.svg';
import { useBrandContext } from '../../context/BrandContext';
import Modal from '../modal/Modal';
import { Props } from './interfaces';
import './styles.css';

const ToastHelp = ({
  isModalOpen,
  setShowHelpToast,
  allowButtonClosed
}: Props) => {
  const brandContext = useBrandContext();

  return (
    <Modal
      allowButtonClosed={allowButtonClosed}
      isOpen={isModalOpen}
      onClose={() => setShowHelpToast(false)}
      title="Ajuda"
    >
      <p>
        Está com alguma dificuldade? Entre em contato através de um dos canais
        de atendimento.
      </p>

      <div className="action-help">
        <a
          className="action-help__button action-help__button--whatsapp"
          href={`https://wa.me/${brandContext?.brandData.appEmailSupportWhatsappNumber}`}
          target="_blank"
          rel="noopener noreferrer"
        >
          WhatsApp
          <img src={whats} alt="WhatsApp" />
        </a>
        <a
          className="action-help__button action-help__button--email"
          href={`mailto:${brandContext?.brandData.appEmailSupportAddress}`}
        >
          E-mail
          <img src={email} alt="E-mail" />
        </a>
      </div>
    </Modal>
  );
};

export default ToastHelp;
